var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'surface-title-root': true,
    'transition-all duration-400 ease-in-out': true,
    'flex justify-start': true,
    'border-box': true,
    'overflow-visible': true,
    'w-full': true,
    'long-title': _vm.isLongTitle,
    'description-present': !!_vm.description,
    'portrait-present': !!_vm.portrait,
  }},[_c('div',{class:{
      'flex flex-shrink-0 items-center justify-center box-content': true,
      'w-10': !_vm.portrait,
      'w-8 h-8 ps-6 pe-4 pt-5.75': _vm.portrait,
      'animate-portrait-enter': !_vm.isCollapsed && _vm.isCollapsed !== null,
      'animate-portrait-leave': _vm.isCollapsed,
      'absolute top-0': true,
    },on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}},[(_vm.portrait)?_c('ProcessedImage',{attrs:{"src":_vm.portrait,"width":_vm.portraitSize,"height":_vm.portraitSize,"transforms":{ preset: 'icon', width: _vm.portraitSize, height: _vm.portraitSize },"alt":_vm.__('Icon')}}):_vm._e()],1),_vm._v(" "),_c('div',{class:{ 'flex-shrink-0': true, 'w-10': !_vm.portrait, 'w-18': !!_vm.portrait, absolute: _vm.isCollapsed }}),_vm._v(" "),_c('div',{class:{
      'w-full': true,
      'mt-3.5': !_vm.isCollapsed && !_vm.description,
      'mt-1.5': !_vm.isCollapsed && _vm.description,
    }},[_c('SurfaceBuilder',{class:{
        'text-body-extra-small': true,
        'animate-builder-enter': !_vm.isCollapsed && _vm.isCollapsed !== null,
        'animate-builder-leave': _vm.isCollapsed,
      }}),_vm._v(" "),_c('div',{staticClass:"flex flex-col",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}},[_c('div',{class:{
          'absolute flex ': true,
          'animate-title-collapse': _vm.isCollapsed,
          'animate-title-uncollapse': !_vm.isCollapsed && _vm.isCollapsed !== null,
          'mt-3 mb-3 ms-13.5': _vm.isCollapsed,
          'mt-0 me-4': !_vm.isCollapsed,
          'max-w-[calc(100%-160px)]': _vm.isCollapsed,
        }},[_c('h1',{class:{
            'w-full': true,
            'pe-2': _vm.isCollapsed && _vm.isLongTitle,
            [_vm.fontClass]: true,
            'whitespace-nowrap': _vm.isCollapsed,
            'overflow-ellipsis': _vm.isCollapsed,
            'overflow-hidden': _vm.isCollapsed,
            'text-heading-3': !_vm.isCollapsed,
            'text-heading-4 leading-6': _vm.isCollapsed,
            'font-semibold break-words': true,
            'text-dark-text-100': _vm.isMap ? _vm.colorScheme === 'light' : _vm.backgroundLuminance === 'light',
            'text-light-text-100': _vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',
          }},[_vm._v("\n          "+_vm._s(_vm.title || _vm.__('Untitled padlet'))+"\n        ")]),_vm._v(" "),_c('div',{class:{
            'h-6.5': true,
            'flex items-center': true,
          }},[(!_vm.isLongTitle)?_c('OzIcon',{class:{
              'animate-short-title-caret-collapse ': _vm.isCollapsed,
              'animate-short-title-caret-uncollapse ': !_vm.isCollapsed && _vm.isCollapsed !== null,
              'ms-2': !_vm.isCollapsed,
              'text-dark-text-300': _vm.isMap ? _vm.colorScheme === 'light' : _vm.backgroundLuminance === 'light',
              'text-light-text-300': _vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',
            },attrs:{"name":"chevron_right_center","size":12}}):_vm._e()],1),_vm._v(" "),_c('h1',{class:{
            absolute: true,
            'pe-2': _vm.isCollapsed,
            'w-full': true,
            [_vm.fontClass]: true,
            'text-heading-3': !_vm.isCollapsed,
            'text-heading-4 leading-6': _vm.isCollapsed,
            'animate-title-lines-fade-out-collapse': _vm.isCollapsed,
            'animate-title-lines-fade-in-uncollapse': !_vm.isCollapsed && _vm.isCollapsed !== null,
            'font-semibold break-words': true,
            'text-dark-text-100': _vm.isMap ? _vm.colorScheme === 'light' : _vm.backgroundLuminance === 'light',
            'text-light-text-100': _vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',
          },on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}},[_vm._v("\n          "+_vm._s(_vm.title || _vm.__('Untitled padlet'))+"\n        ")])]),_vm._v(" "),_c('h1',{ref:"title",class:{
          [_vm.fontClass]: true,
          'mt-6.5': _vm.isCollapsed,
          'me-4': !_vm.isCollapsed,
          'text-heading-3': true,
          invisible: true,
          'font-semibold break-words': true,
          'text-dark-text-100': _vm.isMap ? _vm.colorScheme === 'light' : _vm.backgroundLuminance === 'light',
          'text-light-text-100': _vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',
        },on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}},[_vm._v("\n        "+_vm._s(_vm.title || _vm.__('Untitled padlet'))+"\n      ")]),_vm._v(" "),_c('div',{class:{
          'absolute flex-shrink-0 flex flex-row items-start': true,
          'w-full': _vm.isCollapsed,
        }},[_c('h1',{ref:"titlePlaceholderForCaretPosition",class:{
            [_vm.fontClass]: true,
            'mt-3 mb-3 ms-13.5': _vm.isCollapsed,
            'max-w-[calc(100%-180px)]': _vm.isCollapsed,
            'whitespace-nowrap': _vm.isCollapsed,
            'overflow-ellipsis': _vm.isCollapsed,
            'overflow-hidden': _vm.isCollapsed,
            'text-heading-3': !_vm.isCollapsed,
            'text-heading-4 leading-6': _vm.isCollapsed,
            invisible: true,
            'tablet-landscape:text-surface-title font-semibold break-words': true,
            'text-dark-text-100': _vm.isMap ? _vm.colorScheme === 'light' : _vm.backgroundLuminance === 'light',
            'text-light-text-100': _vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',
          },on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}}),_vm._v(" "),_c('div',{class:{
            'h-6.5': !_vm.isCollapsed,
            'h-12': _vm.isCollapsed,
            'flex items-center': true,
          }},[(_vm.isLongTitle)?_c('OzIcon',{class:{
              'animate-title-caret-collapse ': _vm.isCollapsed,
              'animate-title-caret-uncollapse ': !_vm.isCollapsed && _vm.isCollapsed !== null,
              'ms-2': !_vm.isCollapsed,
              'text-dark-text-300': _vm.isMap ? _vm.colorScheme === 'light' : _vm.backgroundLuminance === 'light',
              'text-light-text-300': _vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',
            },attrs:{"name":"chevron_right_center","size":12}}):_vm._e()],1)]),_vm._v(" "),(_vm.description)?_c('SurfaceTitleDescription',{class:[
          'mt-0',
          'me-4',
          {
            'animate-description-enter': !_vm.isCollapsed && _vm.isCollapsed !== null,
            'animate-description-leave': _vm.isCollapsed,
          },
        ],attrs:{"text":_vm.description,"font-id":_vm.fontId,"color-scheme":_vm.isMap ? _vm.colorScheme : _vm.backgroundLuminance}}):_vm._e()],1),_vm._v(" "),_c('div',{class:{
        'h-3': !_vm.isCollapsed,
      }})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }